import React from "react";

function MetricIcon({ icon }) {
  if (!icon) return null;
  const Icon = icon;
  return (
    <span className="title-toolbar-metric-icon" aria-hidden="true">
      <Icon focusable="false" />
    </span>
  );
}

function ToolbarIcon({ icon }) {
  if (!icon) return null;
  const Icon = icon;
  return (
    <span className="title-toolbar-icon" aria-hidden="true">
      <Icon focusable="false" />
    </span>
  );
}

/**
 * Shared, single-row page title appbar. Icon-only actions should use the
 * title-toolbar-icon-action class and provide their own aria-label and title.
 */
export function TitleToolbar({
  title,
  icon,
  leading,
  trailing,
  actions,
  actionsLabel,
  metrics = [],
  metricsLabel = "Page summary",
  density = "default",
  className = "",
  titleId,
}) {
  const generatedTitleId = React.useId();
  const resolvedTitleId = titleId ?? generatedTitleId;
  const rootClassName = [
    "title-toolbar",
    `title-toolbar-${density}`,
    className,
  ].filter(Boolean).join(" ");

  return (
    <header className={rootClassName} aria-labelledby={resolvedTitleId}>
      <ToolbarIcon icon={icon} />
      {leading && <div className="title-toolbar-leading">{leading}</div>}

      <div className="title-toolbar-heading">
        <h1 id={resolvedTitleId}>{title}</h1>
      </div>

      {metrics.length > 0 && (
        <dl className="title-toolbar-metrics" aria-label={metricsLabel}>
          {metrics.map((metric) => (
            <div
              className={`title-toolbar-metric title-toolbar-metric-${metric.tone ?? "default"}`}
              key={metric.id ?? metric.label}
            >
              <MetricIcon icon={metric.icon} />
              <dt>{metric.label}</dt>
              <dd>{metric.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {actions && <div className="title-toolbar-actions" role="group" aria-label={actionsLabel ?? `${title} actions`}>{actions}</div>}
      {trailing && <div className="title-toolbar-trailing">{trailing}</div>}
    </header>
  );
}
